export default function logData(data) {
  if (process.env.VUE_APP_ENV === 'dev') {
    console.log(data)
  }
}
